export default __webpack_public_path__ + "static/media/Circleci.a79c40de.svg";